import { createSlice } from "@reduxjs/toolkit";

type InitialState = {
    value: {
        selectedQnaPage: number;
        qnaLoading: boolean;
        deleteModalVisible: boolean;
        qnaReplyModalVisible: boolean;
        selectedQnaId: string;
        selectedQnaTitle: string;
        qnaReplyString: string;
    }
};

const initialState = {
    value: {
        selectedQnaPage: 1,
        qnaLoading: true,
        deleteModalVisible: false,
        qnaReplyModalVisible: false,
        selectedQnaId: '',
        selectedQnaTitle: '',
        qnaReplyString: '',
    }
} as InitialState;

export const qnaSlice = createSlice({
    name: 'qna',
    initialState,
    reducers: {
        setSelectedQnaPageRedux: (state, action) => {
            state.value.selectedQnaPage = action.payload;
        },
        setQnaLoadingRedux: (state, action) => {
            state.value.qnaLoading = action.payload;
        },
        setDeleteModalVisibleRedux: (state, action) => {
            state.value.deleteModalVisible = action.payload;
        },
        setQnaReplyModalVisibleRedux: (state, action) => {
            state.value.qnaReplyModalVisible = action.payload;
        },
        setSelectedQnaIdRedux: (state, action) => {
            state.value.selectedQnaId = action.payload;
        },
        setSelectedQnaTitleRedux: (state, action) => {
            state.value.selectedQnaTitle = action.payload;
        },
        setQnaReplyStringRedux: (state, action) => {
            state.value.qnaReplyString = action.payload
        }
    },
});

export const {
    setSelectedQnaPageRedux,
    setQnaLoadingRedux,
    setDeleteModalVisibleRedux,
    setSelectedQnaIdRedux,
    setSelectedQnaTitleRedux,
    setQnaReplyStringRedux,
    setQnaReplyModalVisibleRedux,
} = qnaSlice.actions;
export default qnaSlice.reducer;